import { useLocation, useNavigate } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <div className="w-16 h-16 rounded-2xl bg-background-100 flex items-center justify-center mb-4">
        <i className="ri-question-line text-3xl text-foreground-300"></i>
      </div>
      <h1 className="text-lg font-semibold text-foreground-800 font-heading">页面未找到</h1>
      <p className="mt-2 text-xs text-foreground-400">{location.pathname}</p>
      <button
        onClick={() => navigate('/')}
        className="mt-6 px-5 py-2.5 rounded-xl bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
      >
        返回首页
      </button>
    </div>
  );
}